import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";
import { kColors } from "src/kColors";
import { PdText, tPdText } from "src/components/layout";
import { kStyleConst } from "src/kStyle";
import { kFonts } from "src/kFonts";

export const PdFormCard: React.FC<ViewProps> = ({ style, ...rest }) => (
  <View style={[styles.pdFormCard, style]} {...rest} />
);

export const PdSectionBadge: React.FC<ViewProps> = ({ style, ...rest }) => {
  return <View style={[styles.pdSectionBadge, style]} {...rest} />;
};

export const PdSectionBadgeLabel: React.FC<tPdText> = ({ style, ...rest }) => {
  return <PdText style={[styles.pdSectionBadgeLabel, style]} {...rest} />;
};

const styles = StyleSheet.create({
  pdFormCard: {
    backgroundColor: kColors.white,
    padding: kStyleConst.kSpacing * 5,
  },
  pdSectionBadge: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    height: 19,
    justifyContent: "center",
    width: 19,
  },
  pdSectionBadgeLabel: {
    ...kFonts.bodySmallCenter,
    color: kColors.white,
    lineHeight: 19,
  },
});
